import React, { useEffect } from 'react';
import { IconUnlink } from '@tabler/icons-react';
// import { getCurrentLang } from '@/locales';
// import { getQueryStringByName } from '@/utils';
import styles from './index.module.scss';

import { getSpmConfig } from '@/utils/spm';
import { definePageConfig, defineDataLoader } from 'ice';

export const pageConfig = definePageConfig((dataLoader: any) => {
  const params = getSpmConfig(dataLoader);
  return params;
});

export const dataLoader = defineDataLoader(async (ctx) => {
  return ctx;
});

const zhTW = {
  'iWeb.pages.err.title': '哦！出了什麼問題',
  'iWeb.pages.err.desc': '我們無法正常加載頁面，我們再試一次。',
  'iWeb.pages.err.refresh.text': '刷新頁面',
};

const zhCN = {
  'iWeb.pages.err.title': '哦！出了什么问题',
  'iWeb.pages.err.desc': '我们无法正常加载页面，我们再试一次。',
  'iWeb.pages.err.refresh.text': '刷新页面',
};

const enUS = {
  'iWeb.pages.err.title': 'Oh! Something went wrong',
  'iWeb.pages.err.desc': 'We are unable to load the page properly, we will try again.',
  'iWeb.pages.err.refresh.text': 'Refresh page',
};

const messages = {
  'zh-TW': zhTW,
  'zh-CN': zhCN,
  'en-US': enUS,
};

const getMessages = () => {
  return messages['en-US'];
};

const intl = {
  formatMessage: ({ id, defaultMessage }: { id: string; defaultMessage: string }) => {
    // 获取当前语言的消息对象
    const messages = getMessages();
    // 如果没有找到对应的文本，则返回默认文本
    if (!messages) {
      return defaultMessage;
    }
    // 返回找到的文本
    return messages[id] || defaultMessage;
  },
};

const onRefresh = () => {
  if (window.location.hostname.includes('cinematicketing.galaxymacau.com')) {
    window.location.href = 'https://www.galaxymacau.com/zh-hant/cinema/';
  } else {
    window.location.href = '/';
  }
};

/**
 * 错误页面组件
 * 显示错误信息并提供刷新页面的选项
 */
const ErrorPage: React.FC = () => {
  useEffect(() => {
    document.getElementById('root-loading')?.classList.add('root-hidden');
  }, []);

  return (
    <div className={styles['error-container']}>
      <h1 className={styles['title']}>
        <IconUnlink className={styles.icon} />
        <span className="en">
          {intl.formatMessage({ id: 'iWeb.pages.err.title', defaultMessage: '哦！出了什麼問題' })}
        </span>
      </h1>
      <p className={styles['desc']}>
        <span className="en">
          {intl.formatMessage({ id: 'iWeb.pages.err.desc', defaultMessage: '我們無法正常加載頁面，我們再試一次。' })}
        </span>
      </p>
      <a onClick={onRefresh} className={styles['refresh']}>
        <span className="en">
          {intl.formatMessage({ id: 'iWeb.pages.err.refresh.text', defaultMessage: '刷新頁面' })}
        </span>
      </a>
    </div>
  );
};

export default ErrorPage;
